import React from "react";

function GroupIcon({width,height, onClick}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 208 57"
      className="cursor-pointer"
      onClick={onClick}
    >
      <path
        fill="#0D2233"
        d="M67.454 0v56.197h-9.472V0h9.472zm-3.853 0h11.722C79.443 0 83.002.723 86 2.167c2.996 1.446 5.338 3.466 7.024 6.062 1.686 2.597 2.53 5.66 2.53 9.192s-.844 6.611-2.53 9.232c-1.686 2.623-4.028 4.657-7.024 6.102-2.998 1.445-6.557 2.167-10.677 2.167H63.6v-7.867h11.32c2.193 0 4.094-.361 5.7-1.084 1.605-.722 2.863-1.793 3.773-3.21.91-1.418 1.365-3.119 1.365-5.1 0-2.033-.456-3.745-1.365-5.137-.91-1.391-2.168-2.461-3.773-3.211-1.606-.75-3.507-1.124-5.7-1.124H63.6V0zm16.217 29.383l19.107 26.814h-11.48L69.621 29.383h10.196zM111.166 54.592c-2.863-1.606-5.071-3.854-6.623-6.744-1.552-2.89-2.328-6.262-2.328-10.115 0-3.907.789-7.306 2.369-10.197 1.577-2.89 3.813-5.124 6.703-6.703 2.89-1.578 6.289-2.368 10.196-2.368s7.238.75 9.995 2.247c2.756 1.5 4.857 3.653 6.303 6.464 1.444 2.809 2.167 6.195 2.167 10.155 0 .43-.014.883-.04 1.365-.027.482-.04.83-.04 1.044h-32.434v-6.021h24.967l-2.649 3.692c.161-.32.334-.748.522-1.284.187-.535.281-.99.281-1.365 0-1.98-.389-3.693-1.164-5.138-.777-1.445-1.847-2.57-3.211-3.372-1.365-.803-2.958-1.204-4.777-1.204-2.196 0-4.054.482-5.58 1.445-1.525.963-2.703 2.356-3.532 4.174-.83 1.821-1.245 4.069-1.245 6.744-.053 2.623.334 4.871 1.164 6.744.83 1.874 2.02 3.292 3.573 4.255 1.551.963 3.452 1.445 5.7 1.445 2.409 0 4.496-.482 6.262-1.445 1.766-.963 3.211-2.435 4.335-4.416l7.547 2.971c-1.981 3.319-4.496 5.82-7.547 7.506-3.05 1.686-6.717 2.529-10.998 2.529-3.748 0-7.053-.803-9.916-2.408zM170.374 27.536c-1.124-1.39-2.838-2.087-5.138-2.087-1.659 0-3.104.336-4.335 1.004a6.915 6.915 0 00-2.85 2.89c-.67 1.258-1.003 2.717-1.003 4.376v22.478h-8.752v-36.93h8.752v5.7c1.176-2.193 2.689-3.826 4.536-4.897 1.846-1.07 4.026-1.605 6.543-1.605 4.174 0 7.358 1.272 9.553 3.813 2.194 2.543 3.291 6.009 3.291 10.397v23.522h-8.911V33.72c0-2.73-.562-4.79-1.686-6.183zM207.865 19.267v7.627h-20.953v-7.627h20.953zm-6.182-12.844v49.774h-8.509V6.423h8.509z"
      ></path>
      <path
        fill="url(#paint0_linear_2_4)"
        d="M22.228 0c-1.661 5.392-4.037 8.938-5.847 11.136-1.365 1.658-3.071 3.295-6.482 6.568a241.685 241.685 0 01-5.466 5.084c-.387.33-5.166 4.564-4.337 10.847.107.803.829 5.612 5.205 8.222 5.345 3.188 11.03.046 11.353-.14 3.573-2.056 4.901-5.423 5.256-6.43.168 1.221.828 6.993-3.071 12.246-4.841 6.52-12.59 6.69-13.474 6.694a1.551 1.551 0 00-.747.595c-.369.566-.213 1.171-.185 1.27h35.506c.025-.074.205-.63-.127-1.145a1.31 1.31 0 00-.676-.52c-1.008.022-7.33.05-12.078-5.03-5.484-5.869-4.09-13.446-3.94-14.194 1.794 5.1 6.35 8.405 11.143 8.304 3.04-.064 6.335-1.571 8.39-4.448.373-.523 2.415-3.486 1.892-7.239-.32-2.296-1.705-4.07-4.465-7.52-1.775-2.22-3.23-3.753-4.72-5.312-3.099-3.246-5.152-4.98-8.075-8.833-.21-.275-.362-.473-.564-.756C25.351 7.481 23.522 4.424 22.23 0z"
      ></path>
      <path
        fill="url(#paint1_linear_2_4)"
        d="M23.118 35.203c.09.273 2.38 6.81 8.698 8.06.643.127 4.653.853 8.298-1.702 2.662-1.867 3.65-4.449 3.906-5.144.235-.639.647-1.79.624-3.305-.032-2.202-.96-3.862-1.501-4.75-2.735-4.491-7.382-8.696-11.785-13.455-3.996-4.32-5.283-6.386-5.881-7.404A33.685 33.685 0 0122.228 0c-2.132 8.3-.968 13.766.547 17.264 1.588 3.667 4.063 6.328 3.755 10.553-.237 3.246-1.996 5.778-3.412 7.386z"
      ></path>
      <path
        fill="url(#paint2_linear_2_4)"
        d="M21.91 35.288c.242 1.6.592 5.43-1.38 9.544-2.49 5.201-7.04 7.416-8.884 8.16a17.217 17.217 0 01-6.282 1.236 1.43 1.43 0 00-.505.311c-.584.563-.446 1.442-.426 1.553h35.524c.026-.08.179-.57-.1-1.066a1.341 1.341 0 00-.721-.598c-1.074.019-7.116.022-11.797-4.749-5.755-5.867-4.36-13.763-4.22-14.476l-1.209.085z"
        opacity="0.87"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_2_4"
          x1="44.629"
          x2="0"
          y1="28.046"
          y2="28.046"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#124D95"></stop>
          <stop offset="0.586" stopColor="#156FB8"></stop>
          <stop offset="1" stopColor="#2086C8"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_2_4"
          x1="44.645"
          x2="21.063"
          y1="21.727"
          y2="21.727"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF9A66"></stop>
          <stop offset="1" stopColor="#F0E620"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_2_4"
          x1="40.022"
          x2="4.405"
          y1="45.648"
          y2="45.648"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00C8CD"></stop>
          <stop offset="1" stopColor="#31727C"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default GroupIcon;
